// Polyfills must be imported before React
import '@wix/da-react-app/pkg/client/polyfills';

/* eslint-disable @wix/da/import-scss-last */
import { hydrateRoot } from 'react-dom/client';
import initI18n from '@wix/da-i18next/pkg/presetI18nClientConfigNg';
// project-base needs to go before app styles
import '@wix/da-ds/src/styles/project-base.scss';
import App from './components/App';
import { getRootErrorCallbacks } from '@wix/da-react-app/pkg/client/rootErrorCallbacks';
import { Router } from 'react-router-dom';
import { configureStore } from './store/configureStore';
import {
  routerSafeHistory as history,
  configureHistoryListener,
} from '@wix/da-shared-react/pkg/redux/routing/history';
import { getClientInstance } from '@wix/da-ddt';
import Modal from 'react-modal';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import AppDocumentWrapper from '@wix/da-react-app/pkg/client/AppDocumentWrapper';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import { getProfileTheme, getProfileThemeSkin } from './selectors/profileSkins';

const ddt = getClientInstance();
ddt.replayServerSideLogs(window['__DDT__']);

const initialI18n = window['__INITIAL_I18N__'];

const initialState = window['__INITIAL_STATE__'];
delete window['__INITIAL_STATE__'];
const store = configureStore(initialState);
configureHistoryListener(store);
initI18n(
  {
    ...initialI18n,
    options: {
      fallbackNS: 'translation',
    },
  },
  getEnv(store.getState()).isDebug,
  getEnv(store.getState()).flags
);

Modal.setAppElement('body');
hydrateRoot(
  document,
  <I18nextProvider i18n={i18n}>
    <AppDocumentWrapper
      store={store}
      themeSelector={getProfileTheme}
      themeSkinSelector={getProfileThemeSkin}
    >
      <Router history={history}>
        <App
          language={initialI18n.locale}
          userAgent={(window && window.navigator && window.navigator.userAgent) || ''}
        />
      </Router>
    </AppDocumentWrapper>
  </I18nextProvider>,
  getRootErrorCallbacks('user-profile')
);
